import dateHelper from '../functions/dateHelper.js'
import gapFromTime from '../functions/gapFromTime.js'

import { GAP_GIFT_CARD, GAP_ALL_DAY } from '../settings.js'

function getDateError ({ cart, type }) {
  // Gift cards aren't bound to dates.
  if (cart[type].gap === GAP_GIFT_CARD) {
    return
  }

  // Skip empty carts.
  if (!cart[type].total_articles) {
    return
  }

  const today = dateHelper.getDate()
  const cartDate = new Date(cart[type].date)
  cartDate.setHours(0, 0, 0, 0)

  // Cart date is in the future.
  if (cartDate > today) {
    return
  }

  const currentGap = gapFromTime(new Date())

  // Cart date is from later in the day.
  if (cartDate.getTime() === today.getTime() && cart[type].gap >= currentGap) {
    return
  }

  return 'cartError.expired'
}

export default {
  computed: {
    cartValidation () {
      const result = {
        valid: true,
        error: '',
        errorArgs: {}
      }

      const cart = this.$store.state.cart

      // Error if cart is empty.
      if (!cart.total) {
        result.error = 'cartError.empty'
      }

      if (cart.events.total_articles > 14) {
        result.error = 'cartError.tooManyEvents'
      }

      // Error if cart contains vouchers but no tickets.
      if (
        !cart.tickets.total_articles &&
        !cart.events.total_articles &&
        !cart.tours.total_articles &&
        cart.vouchers.total_articles
      ) {
        result.error = 'cartError.vouchers'
      }

      // Error if cart contains all-day tickets (gap 100) but not enough experiences.
      const minimumExperiences = Math.max(cart.tickets.total_articles - this.$store.state.toursConfig.erlebnis_ticket_abweichung, 1)
      const missingExperiences = minimumExperiences - cart.tours.total_articles
      if (
        cart.tickets.gap === GAP_ALL_DAY &&
        missingExperiences > 0
      ) {
        result.error = 'cartError.tours'
        result.errorArgs = { minimumExperiences: minimumExperiences }
      }

      // Error if cart contains tickets or events from the past.
      const ticketsDateError = getDateError({ cart, type: 'tickets' })
      const eventsDateError = getDateError({ cart, type: 'events' })

      if (ticketsDateError) {
        result.error = ticketsDateError
      }

      if (eventsDateError) {
        result.error = eventsDateError
      }

      if (!cart.tickets.total_articles && cart.tours.total_articles) {
        for (const article in cart.tours.articles) {
          if (article.startsWith('2_') && article.endsWith('_25')) {
            result.error = 'cartError.comboTickets'
          }
        }
      }

      if (result.error) {
        result.valid = false
      }

      return result
    }
  }
}
